// extracted by mini-css-extract-plugin
export default {"matchDetailsContainer":"_12UB_","matchTitle":"_35OCf","matchScores":"_190Aq","singleEvent":"_3nUz2","matchInformation":"_3fSKm","liveIndicatorIcon":"_1D5Of"};